<div #header mat-dialog-title>
    {{type}}
</div>

<div style="padding-left: 10px;">{{attendanceDate | date:'MM/dd/yy'}}</div>

<div style="padding-left:65%;">
    Step 2 of 3 - Enter Changes
</div>

<mat-dialog-content>
    <div>
        <tyl-time-field #timeInput style="margin-right: 20px;width: 150px;" label="Time" id="timeInput" name="timeInput"
            width="130px" [required]="true" [(timeValue)]="checkInOutTime" (timeFieldChange)="timeField = $event"
            [showNowButton]="true"></tyl-time-field>
    </div>

    <div>
        <tyl-checkbox id='chkOverwrite' [(checked)]="overwriteAttendanceCodes">
            <span translate>Overwrite existing codes for prior periods</span>
        </tyl-checkbox>
    </div>

    <div style="padding-top: 10px;">
        <tyl-form-field label="Prior Periods Code" style="width: 150px;">
            <mat-select #periodCode [(ngModel)]="selectedAttendanceCode" [required]="true" name="stateReporting"
                id="stateReporting">
                <mat-option *ngFor="let item of attendanceCodes;" [value]="item.Id">
                    <span>{{item.CodeDescription}}</span>
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>

    <div style="padding-left: 80%;">
        <a class="link" (click)="setToDefault();">Set to Default</a>
    </div>

    <div>
        <tyl-form-field label="Daily/Period Comment" style="width:100%">
            <textarea matInput name="txtReason" Id="txtReason"
                style="resize: none;width:100%;vertical-align:top;padding-top:0px;padding-bottom:0px;"
                [(ngModel)]="dailyPeriodComment" rows="4"></textarea>
        </tyl-form-field>
    </div>

    <div style="padding-top: 10px;">
        <tyl-checkbox id='chkUpdatePeriodComment' [(checked)]="updatePeriodComment">
            <span translate>Update Period Comment</span>
        </tyl-checkbox>
    </div>

    <div style="padding-left: 30px;">
        <tyl-radio-group #elementaryMethod arrange="vertical" name="selectPeriodComment" [disabled]="!updatePeriodComment"
            [(selected)]="periodComment" [values]="['A', 'O']"
            [labels]="['Append to comment', 'Overwrite existing comment']"
            [ids]="['PA', 'PO']">
        </tyl-radio-group>
    </div>

    <div style="padding-top: 10px;">
        <tyl-checkbox id='chkUpdateDailyComment' [(checked)]="updateDailyComment">
            <span translate>Update Daily Comment</span>
        </tyl-checkbox>
    </div>

    <div style="padding-left: 30px;">
        <tyl-radio-group #elementaryMethod arrange="vertical" name="selectDailyComment" [disabled]="!updateDailyComment"
            [(selected)]="dailyComment" [values]="['A', 'O']"
            [labels]="['Append to comment', 'Overwrite existing comment']"
            [ids]="['DA', 'DO']">
        </tyl-radio-group>
    </div>
</mat-dialog-content>

<mat-dialog-actions #footer>
    <div class='flex-footer-left'>
        <tyl-button image="previous arrow.png" label="Previous" (click)="previousClick()"></tyl-button>
    </div>

    <div class='flex-footer-right'>
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="next arrow.png" label="Next" (click)="nextclick()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (click)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>